import { Reducer } from 'redux';
import {
  DeskGroupState,
  DeskGroupActionTypes,
  GET_DESK_GROUP_LIST,
  GET_DESK_GROUP,
  POST_DESK_GROUP,
  PUT_DESK_GROUP,
  DELETE_DESK_GROUP
} from '../types/deskgroup.types';

const initialState: DeskGroupState = {
  deskGroups: [],
  selectedDeskGroup: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1
};

export const deskGroupReducer: Reducer<DeskGroupState> = (
  state: DeskGroupState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as DeskGroupActionTypes).type) {
    case GET_DESK_GROUP_LIST:
      return {
        deskGroups: action.payload.page.content,
        selectedDeskGroup: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_DESK_GROUP:
      return {
        ...state,
        postSuccess: null,
        selectedDeskGroup: action.payload.selectedDeskGroup,
        lastFetch: timeOfAction
      };
    case POST_DESK_GROUP:
      return {
        ...state,
        postSuccess: true,
        selectedDeskGroup: action.payload.newDeskGroup,
        lastFetch: timeOfAction
      };
    case PUT_DESK_GROUP:
      return {
        ...state,
        selectedDeskGroup: action.payload.selectedDeskGroup,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_DESK_GROUP:
      return {
        ...state,
        selectedDeskGroup: null,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
